import axiosClient from "./axiosClient";

const url = "/costumes";

export const costumeApi = {
  // Get costumes with filtering
  getAll(params) {
    return axiosClient.get(url, { params });
  },

  // Get costume by ID
  getById(id) {
    return axiosClient.get(`${url}/${id}`);
  },

  // Create costume
  create(data) {
    return axiosClient.post(url, data);
  },

  // Update costume
  update(id, data) {
    return axiosClient.put(`${url}/${id}`, data);
  },

  // Delete costume
  delete(id) {
    return axiosClient.delete(`${url}/${id}`);
  },
};
